import { render, staticRenderFns } from "./CardsView.vue?vue&type=template&id=11020ffb&scoped=true&"
import script from "./CardsView.vue?vue&type=script&lang=js&"
export * from "./CardsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11020ffb",
  null
  
)

export default component.exports